import { FieldConfigurationType } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type {
  AggregationDescriptor,
  DimensionDescriptor,
  MeasureDescriptor,
  MetaDescriptorBase,
} from "../../../../../../../../api/types/svTypes.ts";
import { MetaItemType } from "../../../../../../../../api/types/svTypes.ts";

export const isDimensionMeta = (meta: MetaDescriptorBase): meta is DimensionDescriptor => {
  return meta.itemType === MetaItemType.DIMENSION;
};

export const isMeasureMeta = (meta: MetaDescriptorBase): meta is MeasureDescriptor => {
  return meta.itemType === MetaItemType.MEASURE;
};

export const isIrrMeasureMeta = (meta: MetaDescriptorBase): meta is MeasureDescriptor => {
  return isMeasureMeta(meta) && meta.configuration?.type === FieldConfigurationType.Irr;
};

export const isAggregationMeta = (meta: MetaDescriptorBase): meta is AggregationDescriptor => {
  return meta.itemType === MetaItemType.AGGREGATION;
};

export const isCustomMeta = (meta: MetaDescriptorBase): boolean => {
  return (isDimensionMeta(meta) || isMeasureMeta(meta)) && meta.custom === true;
};
